module.exports = __webpack_public_path__ + "assets/sync-down-failed-50.992ae94dbe1d413154f4fa7f63b907c9.png";